import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  AssignPermission: {
    to: 'AssignPermissionToRolesListUI',
  },
  BackgroundServerMethodTriggers: {
    icon: 'quartzNetTrigger',
    to: 'BackgroundServerMethodTriggersUI',
  },
  CustomUIViewListUI: {
    icon: 'createCustomView',
    to: 'CustomUIViewListUI',
  },
  Permission: {
    to: 'PermissionUI',
  },
  QuartzNetTests: {
    icon: 'jobAndTriggersTests',
    to: 'QuartzNetTestTriggerUI',
  },
  RemoteScheduledTaskExecutionList: {
    to: 'RemoteScheduledTaskExecutionListUI',
  },
  RemoteScheduledTaskList: {
    to: 'RemoteScheduledTaskListUI',
  },
  ScheduledTaskExecutionLogSearch: {
    to: 'ScheduledTaskExecutionLogSearchUI',
  },
  ScheduledTaskExecutionSearch: {
    to: 'ScheduledTaskExecutionSearchUI',
  },
  ScheduledTaskSearch: {
    to: 'ScheduledTaskSearchUI',
  },
  UserAccount: {
    to: 'UserAccountListUI',
  },
  UserAccountUserRole: {
    to: 'UserAccountUserRoleUI',
  },
  UserSettings: {
    to: 'UserSettingsUI',
  }
}